import { Loader } from "lucide-react";

const CustomLoader = () => {
  return (
    <div className="text-center py-20">
      <div className="relative">
        <Loader className="w-12 h-12 text-primary-500 animate-spin mx-auto mb-4" />
        <div className="text-lg font-medium text-secondary-600">
          Loading your data...
        </div>
        <div className="text-sm text-secondary-500 mt-2">
          Please wait while we fetch your data
        </div>
      </div>
    </div>
  );
};

export default CustomLoader;
